import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class SuspendDriverService extends BaseGetProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.suspendDriver();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(id: number, suspend: string, comment: string): {
    user_id: number;
    sub_status: string;
    comment: string;
} {
    const params: {
      user_id: number;
      sub_status: string;
      comment: string;
  } = {
      user_id: id,
      sub_status: suspend,
      comment,
    };

    return params;
  }
}
